import { ReactNode } from "react";
import { CircularProgress, Stack, Typography } from "@mui/material";
import { ReuseTooltip } from "components/ui/ReuseTooltip";
import { DisconnectCRMBtn } from "../../buttons/DisconnectCRMBtn";
import { CrmTypes } from "types";
import { CustomButton } from "../../CustomButton";
import { CheckInCircleIcon, DisconnectIcon } from "../../../images";

export const CRMMethod = ({
  icon,
  title,
  text,
  btnHandler,
  isLoading,
  isSynced,
  isDisabled,
  isUpdate,
  isConnected = true,
  onDisconnect,
  customBtn,
}: {
  icon: ReactNode;
  title: string;
  text: string;
  btnHandler: () => void;
  isLoading: boolean;
  isSynced: boolean;
  isDisabled: boolean;
  isUpdate?: boolean;
  isConnected?: boolean;
  onDisconnect: () => void;
  customBtn?: ReactNode;
}) => {
  return (
    <Stack
      sx={{
        gap: "16px",
        border: "1px solid #D9D9D9",
        borderRadius: "8px",
        padding: "16px",
        flexDirection: isUpdate ? "row" : "column",
        justifyContent: isUpdate ? "space-between" : "flex-start",
        ...(isSynced && isConnected && { paddingRight: 0 }),
      }}
    >
      <Stack gap="8px" justifyContent="center">
        <Stack flexDirection="row" gap="4px" alignItems="center">
          {icon}
          <Typography
            component="span"
            variant="button"
            color="custom.textDarkBlue"
          >
            {title}
          </Typography>
        </Stack>
        {!isUpdate && (
          <Typography component="span" variant="caption" color="#4C545B">
            {text}
          </Typography>
        )}
      </Stack>
      {isSynced && !customBtn ? (
        <Stack flexDirection="row" gap="4px" alignItems="center">
          <ReuseTooltip
            text={
              !isConnected
                ? `${title} is disconnected. Click ‘Re-sync’ to reconnect and upload data.`
                : ""
            }
            hideChildren={false}
          >
            <Typography component="span" variant="button" color="#4C545B">
              {isConnected ? "Synced" : "Disconnected"}
            </Typography>
          </ReuseTooltip>

          {isConnected ? (
            <Stack flexDirection="row" alignItems="center">
              <CheckInCircleIcon />
              <DisconnectCRMBtn
                crm={title.toLowerCase() as CrmTypes}
                onDisconnect={onDisconnect}
              />
            </Stack>
          ) : (
            <DisconnectIcon />
          )}
        </Stack>
      ) : customBtn ? (
        customBtn
      ) : (
        <CustomButton
          onClick={btnHandler}
          variant="outlined"
          customColor="#FFFFFF"
          textColor="#1D3E70"
          type="button"
          customSize="fit"
          sx={{
            height: "32px",
            borderColor: "#1D3E70",
          }}
          disabled={isDisabled || isLoading}
        >
          Sync Data{" "}
          {isLoading && <CircularProgress size={20} color="inherit" />}
        </CustomButton>
      )}
    </Stack>
  );
};
